module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "headshots_BWG_CHLOE.14e1f5b9.jpg";